import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import { createPortal } from "react-dom";

/**
 * COMPONENTE FOTO (reutilizável)
 * --------------------------------
 * Props:
 *  show: boolean
 *  onClose: function
 *  foto: string (url/base64)
 *  nome: string (GRANDE)
 *  info01: string (MÉDIO)
 *  info02: string (MENOR)
 */

export default function Foto({
  show,
  onClose,
  foto,
  nome,
  info01,
  info02,
}) {
  const [fullscreen, setFullscreen] = useState(false);

  // 🔥 FULLSCREEN VIA PORTAL (corrige problema de ficar preso no card)
  const fullscreenView = (
    <AnimatePresence>
      {fullscreen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="foto-fullscreen"
          onClick={() => setFullscreen(false)}
        >
          <motion.img
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.9 }}
            src={foto}
            alt="Foto ampliada"
            className="foto-fullscreen-img"
          />

          <div className="foto-fullscreen-nome">{nome}</div>
        </motion.div>
      )}
    </AnimatePresence>
  );

  return (
    <>
      {/* MODAL PRINCIPAL */}
      <Modal
        show={show}
        onHide={onClose}
        centered
        backdrop="static"
        dialogClassName="foto-modal-dialog"
        contentClassName="bg-dark text-white border-0"
      >
        <Modal.Header closeButton closeVariant="white" className="border-0" />

        <Modal.Body className="p-0 d-flex flex-column align-items-center justify-content-center">
          <div className="w-100 d-flex justify-content-center align-items-center foto-img-wrapper">
            {foto && (
              <img
                src={foto}
                alt="Foto"
                onClick={() => setFullscreen(true)}
                className="foto-img"
              />
            )}
          </div>

          <div className="w-100 text-center px-3 pb-3">
            <div className="foto-nome">{nome}</div>
            {info01 && <div className="foto-info1">{info01}</div>}
            {info02 && <div className="foto-info2">{info02}</div>}
          </div>
        </Modal.Body>

        <Modal.Footer className="border-0 justify-content-center">
          <Button variant="outline-light" onClick={onClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* 🚀 PORTAL GARANTE TELA INTEIRA REAL */}
      {typeof document !== "undefined" &&
        createPortal(fullscreenView, document.body)}

      {/* ESTILOS */}
      <style jsx>{`
        /* ===== TAMANHO FIXO DO MODAL ===== */
        :global(.foto-modal-dialog) {
          max-width: 720px;
        }

        /* Mobile = tela cheia */
        @media (max-width: 768px) {
          :global(.foto-modal-dialog) {
            max-width: 100vw;
            margin: 0;
            height: 100vh;
          }

          :global(.foto-modal-dialog .modal-content) {
            height: 100vh;
            border-radius: 0;
          }
        }

        /* ===== IMAGEM ===== */
        .foto-img-wrapper {
          height: clamp(260px, 55vh, 420px);
        }

        .foto-img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          cursor: zoom-in;
          border-radius: 16px;
        }

        /* ===== TEXTOS ===== */
        .foto-nome {
          font-size: clamp(1.4rem, 2.5vw, 1.8rem);
          font-weight: 700;
          margin-top: 12px;
        }

        .foto-info1 {
          font-size: clamp(1rem, 2.2vw, 1.2rem);
          opacity: 0.9;
        }

        .foto-info2 {
          font-size: clamp(0.85rem, 2vw, 0.95rem);
          opacity: 0.7;
        }

        /* ===== FULLSCREEN ===== */
        .foto-fullscreen {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.96);
          z-index: 9999; /* 🔥 acima de qualquer card */
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          padding: 20px;
          cursor: zoom-out;
        }

        .foto-fullscreen-img {
          max-width: 100%;
          max-height: 85vh;
          object-fit: contain;
        }

        .foto-fullscreen-nome {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          background: rgba(0, 0, 0, 0.9);
          color: #fff;
          text-align: center;
          padding: 14px 10px;
          font-weight: 700;
          font-size: 1.2rem;
        }
      `}</style>
    </>
  );
}

/**
 * ================= COMO USAR =================
 *
 * <Foto
 *   show={!!fotoSelecionada}
 *   onClose={() => setFotoSelecionada(null)}
 *   foto={fotoSelecionada?.foto}
 *   nome={fotoSelecionada?.nome}
 *   info01={fotoSelecionada?.loja}
 *   info02={fotoSelecionada?.cargo}
 * />
 */
